import { Injectable } from '@angular/core';
import { refParamsInitialState, RefParamsStateProps, refParamStateStore } from './ref-param-state.store';
import { select } from '@ngneat/elf';
import { BaseStoreRepository } from '../base-store.repository';

@Injectable({
  providedIn: 'root',
})
export class RefParamRepository extends BaseStoreRepository<RefParamsStateProps> {
  constructor() {
    super(refParamStateStore.pipe(select(state => state)), refParamStateStore, refParamsInitialState);
  }
}
